/* CREAMORE — 机型数据分批合并

   机型库已经二十多 K，每次扩充都重写一次不现实，所以拆成批次文件：
     creamore-machines.json      主文件（products 的 SKU 清单 + 第一批机型）
     creamore-machines-b2.json   第二批（新增品牌）
     creamore-machines-b3.json   第三批（补图）
     creamore-machines-b4.json   第四批（补 Europiccola 的图）
     creamore-machines-b5.json   第五批（补 2026-08 新品的 SKU）
     creamore-machines-b6.json   第六批（Breville Oracle Jet / Oracle Dual Boiler）
   以后再加就新建 b7，把文件名填进下面 EXTRA 即可。

   实现方式：透明拦截对主文件的 fetch，合并后返回。
   section 里的代码一行不用改，删掉本文件就完整回退到只读主文件。

   合并规则：
     machines —— 按顺序拼接，同名（brand+model）后来者覆盖，
                 所以可以用新批次只重写要修的那几条。
     products —— 主文件为准，批次里的 SKU 追加到对应清单末尾并去重。
                 追加而不是覆盖，是因为清单顺序有含义：排最前的决定
                 「点进去默认选中哪个变体」，放最常卖的。新品排后面正好。
     _* 元信息 —— 只取主文件。

   ⚠️ 必须在 finder 发请求之前装好。theme.liquid 里用 defer 加载，
   defer 在 DOMContentLoaded 前执行，而 finder 是 focus/input 才拉数据，来得及。
*/
(function () {
  if (window.__crMachinesMerge) return;
  window.__crMachinesMerge = true;

  var EXTRA = [
    'creamore-machines-b2.json',
    'creamore-machines-b3.json',
    'creamore-machines-b4.json',
    'creamore-machines-b5.json',
    'creamore-machines-b6.json'
  ];
  var MAIN = /creamore-machines\.json/;
  var cache = null;

  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!MAIN.test(url)) return _fetch.apply(this, arguments);

    if (cache) return Promise.resolve(new Response(cache, { headers: { 'Content-Type': 'application/json' } }));

    var base = url.replace(/creamore-machines\.json.*$/, '');
    var qs = (url.split('creamore-machines.json')[1] || '');
    return Promise.all([_fetch(url).then(function (r) { return r.json(); })].concat(
      EXTRA.map(function (f) {
        return _fetch(base + f + qs).then(function (r) { return r.json(); }).catch(function () { return { machines: [] }; });
      })
    )).then(function (parts) {
      var db = parts[0], seen = {}, all = [];
      parts.forEach(function (p) {
        (p.machines || []).forEach(function (m) {
          var k = ((m.brand || '') + '|' + (m.model || '')).toLowerCase();
          if (seen[k] !== undefined) { all[seen[k]] = m; return; }
          seen[k] = all.length; all.push(m);
        });
      });
      db.machines = all;

      db.products = db.products || {};
      parts.slice(1).forEach(function (p) {
        Object.keys(p.products || {}).forEach(function (k) {
          var list = db.products[k] || (db.products[k] = []);
          p.products[k].forEach(function (sku) {
            if (list.indexOf(sku) < 0) list.push(sku);
          });
        });
      });

      cache = JSON.stringify(db);
      return new Response(cache, { headers: { 'Content-Type': 'application/json' } });
    });
  };
})();
